import type { RouteObject } from 'react-router';

import { CasesPage } from './Cases';

/**
 * `/cases` — the operator's case queue. One `RouteObject`, so the file is
 * `.route.tsx` singular; the feature's two routes are aggregated in
 * `cases.routes.tsx` one level up.
 *
 * **`cases/` is a bucket in the UI/UX pack and never a URL segment.** A
 * breadcrumb states position in the URL, so this route carries two levels.
 *
 * It adds no loader: the console layout route already runs the guard chain, and
 * `backend-support` re-checks the caller's own `support__user_roles` on the
 * request itself.
 */
export const casesRoute: RouteObject = {
  path: 'cases',
  element: <CasesPage />,
};
